import { render, staticRenderFns } from "./MyFirstDataEditor.vue?vue&type=template&id=6a8261fc&scoped=true"
import script from "./MyFirstDataEditor.vue?vue&type=script&lang=js"
export * from "./MyFirstDataEditor.vue?vue&type=script&lang=js"
import style0 from "./MyFirstDataEditor.vue?vue&type=style&index=0&id=6a8261fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8261fc",
  null
  
)

export default component.exports